export const REMOVE_MESSAGES = 'exchange.REMOVE_MESSAGES';
export const SET_MESSAGE = 'exchange.SET_MESSAGE';

export const removeMessages = () => ({ type: REMOVE_MESSAGES });
export const setMessage = errorCode => ({ type: SET_MESSAGE, errorCode });
